import EmailReviewQueuePage from "../features/crm/EmailReviewQueuePage";

export default function EmailReviewQueueRoute() {
  return <EmailReviewQueuePage />;
}
